"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ChatMessage;
var react_1 = __importDefault(require("react"));
var message_bubble_1 = __importDefault(require("./message-bubble"));
var request_bubble_1 = __importDefault(require("./request-bubble"));
function ChatMessage(_a) {
    var message = _a.message, openChat = _a.openChat, contacts = _a.contacts;
    var isMessageRequest = message.request_id !== null;
    var correspondingRequest = openChat.requests.find(function (request) { return request.id === message.request_id; });
    return (react_1.default.createElement(react_1.default.Fragment, null, !isMessageRequest || !correspondingRequest ? (react_1.default.createElement(message_bubble_1.default, { message: message, openChat: openChat, contacts: contacts })) : (react_1.default.createElement(request_bubble_1.default, { request: correspondingRequest, rental: openChat.rental }))));
}
